import { TableServiceRequestCell } from '../../Table'

function TaskTableRowRequest({ item, ...restProps }) {
  const { request } = item

  return <TableServiceRequestCell {...restProps} items={[request]} />
}

export default TaskTableRowRequest
